import { useMemo } from 'react';
import { ProfessionalProfessions } from '~/constants';
import { getShouldOfficeShowEfda } from '~/growthbook';
import { getAllProfessionTypeOptions } from '~/utils/DentistUtils';

export const useProfessionOptions = ({ isShowAllOpt = false } = {}) => {
  const options = useMemo(() => {
    const isShowEFDA = getShouldOfficeShowEfda();

    return [
      ...(isShowAllOpt
        ? [
            {
              label: 'All Profession Type',
              value: 'all',
            },
          ]
        : []),
      ...getAllProfessionTypeOptions(ProfessionalProfessions, {
        showEfda: isShowEFDA,
      }).map((it) => ({
        label: it.name,
        value: it.code,
      })),
    ];
  }, [isShowAllOpt]);

  return options;
};
